import React, {useState} from 'react';
import {withStyles} from "@material-ui/core/styles";
import QuestionComment from "./QuestionComment";

const styles = {
  row:{display: "flex", flexWrap: "wrap", gap: "1rem", justifyContent: "space-between"},
  column:{
    display: "flex",
    flexDirection: "column",
    opacity: 0,
    transition: "opacity 0.5s",
    '&:hover': {
      opacity: 1
    }
  },
}
function QuestionCommentSection(props) {
  const { surveyAttempt, submitAnswer, questionIndex, isViewingShared, children, classes } = props;

  const {answers, survey:{questions}} = surveyAttempt;
  const [answerId=questions[questionIndex].id, values, answerDate, comment="", commentDate=null] = (answers[questionIndex] || []);

  const [commentOpen, setCommentOpen] = useState(false);

  const setComment = (comment, callback=()=>{}) =>
    submitAnswer(answerId, values, answerDate||new Date(Date.now()), comment, new Date(Date.now()), callback);

  return (
    <div className={classes.row}>
      <QuestionComment
        comment={comment}
        commentDate={commentDate}
        setComment={setComment}
        commentOpen={commentOpen}
        setCommentOpen={setCommentOpen}
        isViewingShared={isViewingShared}
      />
      {isViewingShared ? null : children }
      {/*{isViewingShared ? null :*/}
      {/*  <div className={classes.column}>*/}
      {/*    <div>*/}
      {/*      <Button*/}
      {/*        variant={"contained"}*/}
      {/*        size={"small"}*/}
      {/*        margin={"dense"}*/}
      {/*        onClick={() => {*/}
      {/*          if(!answerAllSurvey) {*/}
      {/*            return;*/}
      {/*          }*/}
      {/*          answerAllSurvey(null, () => {*/}
      {/*            setTimeout(() => setQuestionIndex(question_count), 500);*/}
      {/*          })*/}
      {/*        }}*/}
      {/*      >Answer All Random</Button>*/}
      {/*    </div>*/}
      {/*    {children}*/}
      {/*  </div>*/}
      {/*}*/}
    </div>
  )
}

export default withStyles(styles)(QuestionCommentSection);